module.exports = __webpack_public_path__ + "static/media/cbt-icon.f9b64851.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/cbt-icon.svg
// module id = 1027
// module chunks = 0